import { render, staticRenderFns } from "./PrintTitle.vue?vue&type=template&id=394006be&scoped=true&"
import script from "./PrintTitle.vue?vue&type=script&lang=ts&"
export * from "./PrintTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394006be",
  null
  
)

export default component.exports